module.exports = __webpack_public_path__ + "img/banner.1ca138f9.jpg";